<template>
  <section class="b-confirm">
    <div v-show="is_show" class="b-confirm__title">
      {{ $t('core.register.confirm.title') }}
    </div>

    <div v-show="sending_sms" class="text-center">
      {{ $t('core.register.confirm.sending_sms') }}
    </div>

    <div v-show="is_show">
      <div class="b-confirm__text">
        {{ $t('core.register.confirm.text') }}
      </div>
      <div class="b-confirm__number">+{{ phone_format }}</div>

      <div class="b-confirm__changenumber">
        <a href="javascript:void(0);" @click="change_phone">
          {{ $t('core.register.button.use_different_number') }}
        </a>
      </div>

      <label>{{ $t('core.register.phone_verify_code') }}</label>
      <validation-observer ref="code" class="mb-5">
        <z-form-input name="code" :rules="{ required: true }">
          <div class="row align-items-center">
            <div class="col-6">
              <i-input ref="code" v-model="code" :disabled="is_waiting_code_timer_started2" />
            </div>
            <div class="col-5">
              <div v-show="is_waiting_code_timer_started" class="verification-timer">
                {{ current_time }}
              </div>
              <i-button
                v-show="is_waiting_code_timer_finished || is_waiting_code_timer_started2 || is_waiting_code_timer_finished2"
                html-type="button"
                :disabled="!is_waiting_code_timer_finished && !is_waiting_code_timer_finished2"
                class="auth-content__form__submit"
                type="primary"
                :loading="$wait.is('register:check_code')"
                @click="restart_timer"
              >
                {{ $t('core.register.button.new_code') }}
              </i-button>
            </div>

            <div v-show="is_waiting_code_timer_started2" class="col-1 verification-timer">
              {{ current_time2 }}
            </div>
          </div>
        </z-form-input>
      </validation-observer>
    <!-- 
      <div v-show="modal.showing" class="b-modal">
        <div class="b-modal__inner">
          <div class="b-modal__text">
            {{ $t('core.register.confirm.change_number_text') }}
          </div>
          <div class="b-modal__number">+{{ phone_format }}</div>
          <div class="b-modal__buttons">
            <i-button size="large" @click="change_phone">
              {{ $t('core.register.button.change_number') }}
            </i-button>

            <i-button type="success" size="large" @click="restart_timer">
              {{ $t('core.register.button.resend') }}
            </i-button>
          </div>
        </div>
      </div> -->
    </div>
    <auth-link v-show="is_show" />
  </section>
</template>

<script>
  import AuthLink from './register-form-auth-link';
  import { Storage } from '@app/plugins/storage';
  import { seconds_to_time } from '@shared/helpers/time';
  import { SmsVerificationService } from '@core/services/SmsVerificationService';
  import { StateMixin } from '@core/components/auth/register-form/register-form.mixin';

  const registration_form_timer = 'registration_form_timer';
  const registration_form_code = 'registration_form_code';
  const default_timer_seconds = 60;
  const default_timer_1_minute = 60;
  const default_timer_1_hour = 60 * 60;

  export default {
    components: { AuthLink },
    mixins: [StateMixin],
    props: {
      limit_error: {
        type: Number,
        default: 0
      },
      trigger: {
        type: Number,
        default: 0
      },
      phone_format: {
        type: [Number, String],
        default: ''
      }
    },
    data: () => ({
      state: 'init',
      states: {
        init: 'init',
        waiting_code_timer_started: 'waiting_code_timer_started',
        waiting_code_timer_finished: 'waiting_code_timer_finished',
        waiting_code_timer_started2: 'waiting_code_timer_started2',
        waiting_code_timer_finished2: 'waiting_code_timer_finished2',
        code_checked: 'code_checked'
      },
      sending_sms: false,
      modal: {
        showing: false
      },
      code: '',
      sms_timer_interval: false,
      sms_timer_interval2: false,
      seconds: default_timer_seconds,
      timer: default_timer_1_minute
    }),

    computed: {
      is_show() {
        return (
          this.is_waiting_code_timer_started ||
          this.is_waiting_code_timer_finished ||
          this.is_waiting_code_timer_started2 ||
          this.is_waiting_code_timer_finished2
        );
      },
      is_waiting_code_timer_started() {
        return this.state === this.states.waiting_code_timer_started;
      },
      is_waiting_code_timer_finished() {
        return this.state === this.states.waiting_code_timer_finished;
      },
      is_waiting_code_timer_started2() {
        return this.state === this.states.waiting_code_timer_started2;
      },
      is_waiting_code_timer_finished2() {
        return this.state === this.states.waiting_code_timer_finished2;
      },
      current_time() {
        return seconds_to_time(this.seconds);
      },
      current_time2() {
        return seconds_to_time(this.timer);
      }
    },

    watch: {
      code: {
        handler(inputCode) {
          if (inputCode.length === 6) {
            this.verify_code();
          }
        }
      },
      trigger: {
        handler() {
          if (this.limit_error === 1001) {
            this.state = this.states.waiting_code_timer_finished2;
            this.timer = default_timer_1_minute;
            this.start_limit_timer();
          } else if (this.limit_error === 1002) {
            this.timer = default_timer_1_hour;
            this.start_limit_timer();
          }
        }
      }
    },

    mounted() {
      this.reset();
    },

    methods: {
      reset() {
        this.code = '';
        this.seconds = 0;
        Storage.remove(registration_form_timer);
        Storage.remove(registration_form_code);
        this.stop_timer();
        if (this.$refs.code) {
          this.$refs.code.reset();
        }
      },
      set_init() {
        this.state = this.states.init;
        this.reset();
      },
      restart_timer() {
        this.reset();
        this.seconds = default_timer_seconds;
        this.stop_timer();
        this.$emit('timer:restart');
        this.close_modal();
      },
      start_verify() {
        const saved_timer = parseInt(Storage.get(registration_form_timer));
        const is_timer_more_null = Number.isInteger(saved_timer) && saved_timer > 0;
        if (is_timer_more_null) {
          this.seconds = saved_timer;
          this.start_timer();
        } else {
          this.seconds = default_timer_seconds;
          this.start_timer();
        }
        this.$emit('change_step');
      },
      stop_timer() {
        clearInterval(this.sms_timer_interval);
      },
      start_timer() {
        this.on_timer_started();
        // Первый синхронный тик, остальные по интервалу
        this.timer_tick();
        this.stop_timer();
        this.sms_timer_interval = setInterval(() => {
          if (this.seconds > 0) {
            this.timer_tick();
          } else {
            this.state = this.states.waiting_code_timer_finished;
            this.stop_timer();
          }
        }, 1000);
        this.state = this.states.waiting_code_timer_started;
      },
      save_code() {
        Storage.set(registration_form_code, this.code);
      },
      save_timer() {
        Storage.set(registration_form_timer, this.seconds);
      },
      timer_tick() {
        this.seconds = this.seconds - 1;
        this.save_timer();
      },
      start_limit_timer() {
        this.sms_timer_interval2 = setInterval(() => {
          if (this.timer > 0) {
            this.timer = this.timer - 1;
          } else {
            this.state = this.states.waiting_code_timer_finished2;
            clearInterval(this.sms_timer_interval2);
          }
        }, 1000);
        this.state = this.states.waiting_code_timer_started2;
      },
      verify_code() {
        this.state = this.states.validation_phone;
        const params = {
          number: this.phone_format,
          code: this.code
        };

        this.$wait.start('register:check_code');
        SmsVerificationService.check(params)
          .then(() => {
            this.state = this.states.code_checked;
            this.save_code();
            this.on_code_checked(this.code);
          })
          .catch((e) => {
            this.state = this.states.waiting_code_timer_finished;
            this.on_code_not_checked(e);
          })
          .finally(() => {
            this.$wait.end('register:check_code');
            this.reset();
          });
      },
      // Обработка неуспешной валидации кода
      on_code_not_checked(e) {
        this.$emit('remove_data');
        this.$emit('error', e);
      },
      // обработчик успешной проверки кода
      on_code_checked(code) {
        this.$emit('success_data', code);
      },
      show_modal() {
        this.modal.showing = true;
      },
      close_modal() {
        this.modal.showing = false;
      },
      change_phone() {
        this.$emit('change_phone');
        this.close_modal();
      },
      // Смена стейта
      on_timer_started() {
        this.state = this.states.started_timer;
      },

      validate_and_send_sms() {
        this.sending_sms = true;
      }
    }
  };
</script>

<style lang="scss">
  .text-center {
    text-align: center;
  }
  .verification-timer {
    font-size: 18px;
    color: #fff;
    letter-spacing: 2px;
  }
  .b-confirm {
    color: #fff;
    font-family: 'Lato', 'sans-serif';

    &__title {
      font-size: 45px;
      line-height: 50px;
      margin-bottom: 25px;
      text-align: center;
    }

    &__text {
      font-size: 20px;
      line-height: 34px;
    }

    &__number {
      font-size: 20px;
      font-weight: bold;
      line-height: 34px;
      margin-bottom: 10px;
    }

    &__changenumber {
      margin-bottom: 9px;

      a {
        color: #00a6ff;
        font-size: 17px;
        line-height: 34px;
        text-decoration: underline;
      }
    }
  }
  .b-modal {
    background-color: rgba(52, 63, 75, 0.8);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;

    &__inner {
      background: #fff;
      border-radius: 5px;
      width: 500px;
      padding: 20px 35px;
    }

    &__text {
      color: #343f4b;
      font-family: 'Lato', 'sans-serif';
      font-size: 17px;
      line-height: 20px;
    }

    &__number {
      color: #343f4b;
      font-family: 'Lato', 'sans-serif';
      font-size: 20px;
      line-height: 34px;
    }

    &__changebumber {
      margin-bottom: 40px;

      label {
        color: #343f4b;
      }
    }

    &__buttons {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;

      button {
        min-width: 150px;
        font-size: 18px;
        text-transform: none;
        font-weight: 400;
        letter-spacing: normal;
        padding: 12px 20px;
        height: auto;

        &.ivu-btn-success {
          background-color: #00a6ff;
          border-color: #00a6ff;

          &:hover {
            background-color: #33b8ff;
            border-color: #33b8ff;
          }
        }

        &.ivu-btn-default {
          background: #47525e;
          border-color: #47525e;
          color: #fff;

          &:hover {
            background: #647485;
            border-color: #647485;
          }
        }
      }
    }
  }
</style>
